<template>
  <b-row>
    <b-col sm="4">Select Clients:</b-col>
    <b-col sm="8">
      <v-select value='id' label='name' class='select-no-caret' v-model='clients' multiple :options="clientOptions" :closeOnSelect="false" />
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'ClientsSelect',
  components: {
    vSelect
  },

  data () {
    return {
      clients: []
    }
  },

  computed: {
    clientOptions () {
      return this.$store.getters.clients
    }
  },

}

</script>
